import {
  IWizardQuestion,
  IWizardQuestionStore,
  IWizardQuestionsResponse,
  IWizardSectionId,
  IWizardServicesValue,
  IWizardStore,
  IWizardUpdateQuestionItem,
} from "@/interfaces/wizard";
import {
  getWizardQuestion,
  haldleSetupOrganisationOrg,
  initialDataToStore,
  haldleSetupOrganisationGoals,
  hanldleSetupDomains,
  hanldleSetupBrands,
  hanldleSetupMisc,
  hanldleSetupTeams,
  hanldleSetupSite,
  hanldleSetupWebFacing,
  hanldleSetupServices,
  formatServiceSection,
} from "@/services/wizard";
import get from "lodash/get";
import { Module } from "vuex";
import { RootState } from "..";
import {
  WIZARD_STATE_SITES_TYPE_ID,
  WIZARD_STATE_PAGE,
  successStatusCodes,
  WIZARD_STATE_NAME_FROM_ID,
  idWizardPage,
} from "@/utils/constants";
import cloneDeep from "lodash/cloneDeep";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import store from "@/store";
import { getDifferences } from "@/utils/utilities";

const wizardModule: Module<IWizardStore, RootState> = {
  namespaced: true,
  state() {
    return {
      valueSelectInModalGoals: 0,
      valueSelectInModalOrganisation: 0,
      listServiceTypeInServices: [],
      questions: {} as IWizardQuestionStore,
      isShowModalSetupWizard: true,
      currentOrg: 0,
      isStatusApiSetup: false,
      indexUpdate: null,
      valuesServices: [],
      valuesWebservies: [],
      valueSitePage: [],
      valueMisc: {
        miscPII: false,
        miscPHI: false,
      },
      questionsCache: JSON.stringify({}),
    };
  },

  getters: {
    getQuestionsBySection:
      (state) => (pageName: IWizardSectionId, orgId: string) => {
        if (!orgId) return null;

        const questions = state.questions[orgId];
        if (!questions) return null;

        return questions[pageName] || null;
      },
    isShowModal: (state) => state.isShowModalSetupWizard,
    isDirty: (state) => {
      const questions = state.questions[store.state.Org.currentOrg?.id];
      return (
        questions?.goals?.some((e: any) => e?.isSelectedGoals === true) ||
        questions?.org?.some((e: any) => e?.isSelectedOrg === true) ||
        questions?.domains?.some((e: any) => e?.isSelectedDomains === true) ||
        questions?.brands?.some((e: any) => e?.isSelectedBrands === true) ||
        questions?.teams?.some((e: any) => e?.isSelectedTeams === true) ||
        questions?.sites?.some((e: any) => e?.isSelectedSites === true) ||
        questions?.services?.some((e: any) => e?.isSelectedServices === true) ||
        questions?.webservices?.some(
          (e: any) => e?.isSelectedWebFacing === true,
        ) ||
        questions?.misc?.some((e: any) => e?.isSelectedMisc === true) ||
        false
      );
    },
  },
  mutations: {
    SET_VALUE_SERVICES(state, value: IWizardServicesValue[]) {
      state.valuesServices = cloneDeep(value);
    },
    SET_DATA_QUESTION_CACHE(state) {
      state.questionsCache = JSON.stringify(state.questions);
    },
    REFRESH_DATA_QUESTION_FROM_CACHE(state) {
      state.questions = JSON.parse(state.questionsCache);
    },
    SET_SELECT(state, value) {
      state.valueSelectInModalGoals = value;
    },
    RESET_QUESTION(state) {
      state.questions = {};
    },
    SET_CURRENT_ORG(state, value) {
      state.currentOrg = value;
    },
    SET_STATE_API_SETUP(state, value) {
      state.isStatusApiSetup = value;
    },
    SET_INDEX_UPDATE_ITEM(state, value) {
      state.indexUpdate = value;
    },
    SET_SELECT_ORGANISATION(state, value) {
      state.valueSelectInModalOrganisation = value;
    },
    SET_LIST_SERVICE_TYPE(state, value) {
      state.listServiceTypeInServices = value;
    },
    SET_QUESTIONS(state, value: IWizardQuestionStore) {
      const key = Object.keys(value)[0];
      state.questions[key] = value[key];
      state.valueSitePage = cloneDeep(value[key].sites[0].values);
      state.questionsCache = JSON.stringify(state.questions);
    },
    SET_ON_MODAL_SETUP_WIZARD(state, value) {
      state.isShowModalSetupWizard = value;
    },
    SET_VALUES_QUESTIONS(state, { value, orgId, typeId, page }) {
      const pageQuestion = state.questions[orgId]
        ? state.questions[orgId][page]
        : ([] as IWizardQuestion[]);

      if (pageQuestion && pageQuestion.length) {
        const questions = pageQuestion.find((i) => i.questionTypeId === typeId);
        if (questions) {
          const values = questions?.values?.filter((item) => item.id) || [];
          questions.values = [...values, value];
        }
      }
    },

    SET_VALUES_SITES_QUESTIONS(state, { value, orgId, typeId, page }) {
      const questionValue = state.questions[orgId][page][0];
      const pageQuestion = state.questions[orgId]
        ? state.questions[orgId][page][0].types
        : [];

      if (pageQuestion && pageQuestion.length) {
        const questions = pageQuestion.find((i) => {
          return i.typeId === typeId;
        });
        questions && (questions.values = [value]);
        switch (typeId) {
          case WIZARD_STATE_SITES_TYPE_ID.SITE_TYPE:
            questionValue.values[0].typeId = value;
            break;
          case WIZARD_STATE_SITES_TYPE_ID.SITE_LEGAL_TYPE:
            questionValue.values[0].legalTypeId = value;
            break;
          case WIZARD_STATE_SITES_TYPE_ID.SITE_ATTRIBUTE_TYPE:
            questionValue.values[0].attributeTypeId = value;
            break;
        }
      }
    },

    SET_DOMAIN_NAME(state, data: any) {
      if (state.questions[data.currentOrg]?.domains[0]?.values.length > 0) {
        state.questions[data.currentOrg].domains[0].values[data._index] =
          data.value;
      }
    },
    SET_STATE_MISCPII(state, data: any) {
      state.valueMisc.miscPII = data;
    },
    SET_STATE_MISCPHI(state, data: any) {
      state.valueMisc.miscPHI = data;
    },
    SET_VALUES_SERVICE(state, data: any) {
      if (state.questions[data.currentOrg]?.services[0]?.values.length >= 0) {
        const groupValues = formatServiceSection(
          data.value,
          state.questions[data.currentOrg].services[0],
        );
        state.questions[data.currentOrg].services[0].values = data.value;
        state.questions[data.currentOrg].services[0].formatData = groupValues;
      }
    },
    SET_VALUES_SITES(state, data: any) {
      if (state.questions[data.currentOrg]?.sites[0]?.values.length >= 0) {
        state.questions[data.currentOrg].sites[0].values = cloneDeep(
          data.value,
        );
        state.valueSitePage = cloneDeep(data.value);
      }
    },
    SET_VALUES_SERVICE_UPDATE(state, data: any) {
      if (state.questions[data.currentOrg]?.services[0]?.values.length >= 0) {
        if (data.indexUpdate !== undefined || data.value.idUpdate) {
          if (data.value.idUpdate) {
            const index = state.questions[
              data.currentOrg
            ].services[0].values.findIndex(
              (item) => item.idUpdate === data.value.idUpdate,
            );

            if (index === -1) {
              state.questions[data.currentOrg].services[0].values.push(
                data.value,
              );
            } else {
              state.questions[data.currentOrg].services[0].values[index] =
                data.value;
            }
          } else {
            state.questions[data.currentOrg].services[0].values[
              data.indexUpdate
            ] = data.value;
          }
        } else {
          state.questions[data.currentOrg].services[0].values.push(data.value);
        }
      }
    },
    SET_FORMAT_VALUES_SERVICE_UPDATE(state, data: any) {
      if (state.questions[data.currentOrg]?.services[0]?.values.length >= 0) {
        state.questions[data.currentOrg].services[0].formatData[
          data.groupIndex
        ][data.currentIndex] = data.value;
      }
    },
    SET_VALUES_TEAM(state, data: any) {
      if (state.questions[data.currentOrg]?.teams[0]?.values.length >= 0) {
        state.questions[data.currentOrg].teams[0].values = data.value;
      }
    },
    SET_VALUE_MISC(state, data: any) {
      if (state.questions[data.currentOrg]?.misc) {
        state.questions[data.currentOrg].misc = data.value;
      }
    },
    SET_POST_DOMAIN_NAME(state, params: any) {
      if (state.questions[params.currentOrg]?.domains[0]?.values.length > 0) {
        state.questions[params.currentOrg].domains[0].values = params.data;
      }
    },
    SET_POST_BRAND_NAME(state, params: any) {
      if (state.questions[params.currentOrg]?.brands[0]?.values.length > 0) {
        state.questions[params.currentOrg].brands[0].values = params.data;
      }
    },
    SET_MISC_PUSH(state, data: any) {
      if (state.questions[data.currentOrg]?.misc[0]) {
        state.questions[data.currentOrg].misc[0].values.forEach(
          (item) => (item.showAccordion = false),
        );
        state.questions[data.currentOrg].misc[0].values.push(data.objAdd);
      }
    },

    SET_SITES_PUSH(state, data: any) {
      if (state.questions[data.currentOrg]?.sites[0]) {
        state.questions[data.currentOrg].sites[0].values.forEach(
          (item) => (item.showAccordion = false),
        );
        state.questions[data.currentOrg].sites[0].values.push(data.objAdd);
      }
    },

    SET_DOMAIN_NAME_PUSH(state, data: any) {
      if (state.questions[data.currentOrg]?.domains[0]) {
        state.questions[data.currentOrg].domains[0].values.forEach(
          (item) => (item.showAccordion = false),
        );
        state.questions[data.currentOrg].domains[0].values.push(data.objAdd);
      }
    },
    async SET_DOMAIN_NAME_ADD_FORCE(state, data: any) {
      if (state.questions[data.currentOrg]?.domains[0]) {
        state.questions[data.currentOrg].domains[0].values.forEach(
          (item) => (item.showAccordion = false),
        );
        state.questions[data.currentOrg].domains[0].values = state.questions[
          data.currentOrg
        ].domains[0].values.concat(data.domains);
        const listDomains =
          state.questions[store.state.Org.currentOrg?.id].domains;
        const listAnser: any = {
          sectionId: WIZARD_STATE_PAGE.DOMAINS,
          questions: [
            {
              questionTypeId: listDomains[0].questionTypeId,
              values: data.domains,
            },
          ],
        };
        return await hanldleSetupDomains(listAnser);
      }
    },
    SET_BRAND_NAME(state, data: any) {
      if (state.questions[data.currentOrg]?.brands[0]?.values.length > 0) {
        state.questions[data.currentOrg].brands[0].values[data._index] =
          data.value;
      }
    },
    SET_BRAND_NAME_PUSH(state, data: any) {
      if (state.questions[data.currentOrg]?.brands[0]) {
        state.questions[data.currentOrg].brands[0].values.forEach(
          (item) => (item.showAccordion = false),
        );
        state.questions[data.currentOrg].brands[0].values.push(data.objAdd);
      }
    },
    SET_UPDATE_WEBSERVICE(state, { value, orgId, page, questionTypeId }) {
      const pageQuestion = state.questions[orgId]
        ? state.questions[orgId][page]
        : ([] as IWizardQuestion[]);

      if (pageQuestion && pageQuestion.length) {
        const questions = pageQuestion.find((i) => {
          return i.questionTypeId === questionTypeId;
        });
        questions && (questions.values = [value]);
      }
    },
    SET_VALUES_WEBSERVICES(state, data) {
      const arr: any = [];
      data.forEach((el) => {
        el.values.forEach((e) => {
          arr.push(e);
        });
      });
      state.valuesWebservies = arr;
    },
    SET_IS_SELECTED_PAGE_WIZARD(state, data: any) {
      if (!data.currentOrg) {
        data.currentOrg = Object.keys(state.questions)[0];
      }
      if (state.questions[data.currentOrg][data.namePage].length > 0) {
        state.questions[data.currentOrg][data.namePage] = state.questions[
          data.currentOrg
        ][data.namePage].map((item) => {
          return {
            ...item,
            [data.isSelectedPage]: data.isSelected,
          };
        });
      }
    },
    UPDATE_VALUES_ITEM(state, data: IWizardUpdateQuestionItem) {
      if (
        (data.item?.id &&
          data.namePage !==
            WIZARD_STATE_NAME_FROM_ID[idWizardPage.domainPage] &&
          data.namePage !==
            WIZARD_STATE_NAME_FROM_ID[idWizardPage.sitesPage]) ||
        data.type == "UPDATE"
      ) {
        state.questions[data.currentOrg][data.namePage][0].values[data.index] =
          {
            ...state.questions[data.currentOrg][data.namePage][0].values[
              data.index
            ],
            ...data.item,
          };
      } else {
        let values: any = [];
        if (data?.item.idUpdate) {
          const index = state.questions[data.currentOrg][
            data.namePage
          ][0].values.findIndex((item) => item.idUpdate === data.item.idUpdate);
          values = state.questions[data.currentOrg][data.namePage][0].values;
          values.splice(index, 1);
        } else {
          values = state.questions[data.currentOrg][data.namePage][0].values;
          values.splice(data.index, 1);
        }

        state.questions[data.currentOrg][data.namePage][0].values = [...values];
      }
    },

    UPDATE_DATA(state, payload) {
      state.questions[payload.idOrg][payload.sections[0].sectionId] =
        state.questions[payload.idOrg][payload.sections[0].sectionId].map(
          (item) => {
            const updatedMatch = payload.sections[0].questions.find(
              (q) => q.questionTypeId === item.questionTypeId,
            );
            return {
              ...item,
              values: updatedMatch ? updatedMatch.values : item.values,
            };
          },
        );
    },
  },
  actions: {
    handleSetQuestionCache: ({ commit }) => {
      commit("SET_DATA_QUESTION_CACHE");
    },
    handleRefreshQuestionFromCache: ({ commit }) => {
      commit("REFRESH_DATA_QUESTION_FROM_CACHE");
    },
    handleDeleteItem: async ({ state }, data) => {
      let sectionId = data.page;
      if (
        data.page === WIZARD_STATE_PAGE.WEBNAT ||
        data.page === WIZARD_STATE_PAGE.WEB
      ) {
        sectionId = WIZARD_STATE_PAGE.WEBSERVICES;
      }
      const listAnser: any = {
        sectionId,
        questions: [
          {
            questionTypeId:
              sectionId === WIZARD_STATE_PAGE.WEBSERVICES
                ? data.page
                : state.questions[store.state.Org.currentOrg?.id][
                    `${sectionId}`
                  ][0].questionTypeId,
            values: [
              {
                id: data.id,
                isArchived: true,
              },
            ],
          },
        ],
      };
      switch (sectionId) {
        case WIZARD_STATE_PAGE.DOMAINS:
          return await hanldleSetupDomains(listAnser);
        case WIZARD_STATE_PAGE.BRANDS:
          return await hanldleSetupBrands(listAnser);
        case WIZARD_STATE_PAGE.SITES:
          return await hanldleSetupSite(listAnser);
        case WIZARD_STATE_PAGE.TEAMS:
          return await hanldleSetupTeams(listAnser);
        case WIZARD_STATE_PAGE.WEBSERVICES:
          return await hanldleSetupWebFacing(listAnser);
        case WIZARD_STATE_PAGE.SERVICES:
          return await hanldleSetupServices(listAnser);
        default:
          return;
      }
    },
    haldleSetupOrgGoals: async ({ commit, state }) => {
      const listAnser: any = {
        sectionId: WIZARD_STATE_PAGE.GOALS,
        questions: [],
      };
      state.questions[store.state.Org.currentOrg?.id].goals.forEach(
        (el: any, index) => {
          const questionObj = {
            questionTypeId: el.questionTypeId,
            values: el.values.map((element: any) => {
              let keyId;
              let valueKey;
              if (index == 0) {
                keyId = "concernId";
                valueKey = element.concernId ? element.concernId : element;
              } else if (index == 1) {
                keyId = "featureId";
                valueKey = element.featureId ? element.featureId : element;
              } else {
                keyId = "goalId";
                valueKey = element.goalId ? element.goalId : element;
              }
              return {
                [keyId]: valueKey,
                startDate: new Date().toISOString(),
                // description: "",
                // notes: "",
                endDate: new Date().toISOString(),
                ...(element.id ? { id: element.id } : {}),
              };
            }),
          };
          listAnser.questions.push(questionObj);
        },
      );

      listAnser.questions.forEach((element) => {
        element.values = element.values.filter((item) => {
          return !item.id;
        });
      });

      const res = await haldleSetupOrganisationGoals({
        ...listAnser,
        questions: listAnser.questions.filter(
          (q) => q.values && q.values.length > 0,
        ),
      });

      const result = get(res, "data.data");
      commit("UPDATE_DATA", result);

      return res;
    },
    handleSetupDomain: async ({ state }, data) => {
      const listDomains =
        state.questions[store.state.Org.currentOrg?.id].domains;
      const listAnser: any = {
        sectionId: WIZARD_STATE_PAGE.DOMAINS,
        questions: [
          {
            questionTypeId: listDomains[0].questionTypeId,
            values: data.data,
          },
        ],
      };
      return await hanldleSetupDomains(listAnser);
    },

    handleSetupForceDomain: async ({ state }, data) => {
      if (state.questions[data.currentOrg]?.domains[0]) {
        state.questions[data.currentOrg].domains[0].values.forEach(
          (item) => (item.showAccordion = false),
        );
        const oldDomains = state.questions[data.currentOrg].domains[0].values;
        state.questions[data.currentOrg].domains[0].values = state.questions[
          data.currentOrg
        ].domains[0].values.concat(data.domains);
        const listDomains = state.questions[data.currentOrg].domains;
        const listAnser: any = {
          sectionId: WIZARD_STATE_PAGE.DOMAINS,
          questions: [
            {
              questionTypeId: listDomains[0].questionTypeId,
              values: data.domains,
            },
          ],
        };
        try {
          const res = await hanldleSetupDomains(listAnser);
          if (!res || res.status !== successStatusCodes.OK) {
            state.questions[data.currentOrg].domains[0].values = oldDomains;
          }
          return res;
        } catch (error) {
          state.questions[data.currentOrg].domains[0].values = oldDomains;
          return error;
        }
      }
    },

    hanldleSetupBrand: async ({ state }, data) => {
      const listBrand = state.questions[store.state.Org.currentOrg?.id].brands;
      const listAnser: any = {
        sectionId: WIZARD_STATE_PAGE.BRANDS,
        questions: [
          {
            questionTypeId: listBrand[0].questionTypeId,
            values: data.data,
          },
        ],
      };
      return await hanldleSetupBrands(listAnser);
    },

    handleSetupServices: async ({ state, commit }, data) => {
      let formatValues;
      const services =
        state.questions[store.state.Org.currentOrg?.id][
          WIZARD_STATE_PAGE.SERVICES
        ];
      if (data) {
        delete data.updated;
        delete data.indexUpdate;
        delete data.indexGroup;
        delete data.indexCurrent;
        formatValues = [data];
      } else {
        let servicesValues: IWizardServicesValue[] =
          services && services.length ? services[0]?.values || [] : [];
        // Filter items has been updated.
        servicesValues = servicesValues.filter((i) => i.updated === true);
        formatValues = servicesValues.map((i) => {
          const newItem = { ...i };
          delete newItem.updated;
          delete newItem.indexUpdate;
          delete newItem.indexGroup;
          delete newItem.indexCurrent;
          if (!newItem?.endDate?.includes("T") && newItem?.endDate) {
            newItem.endDate = new Date(
              newItem.endDate + "T00:00:00",
            ).toISOString();
          }
          if (i?.id) {
            const dataOriginal = state.valuesServices.find(
              (item) => item.id === i.id,
            );
            const diffObject = getDifferences(newItem, dataOriginal ?? {});
            delete diffObject.idUpdate;
            return diffObject;
          } else {
            if (!newItem.notes) {
              delete newItem.notes;
            }
            if (!newItem.description) {
              delete newItem.description;
            }
            delete newItem.idUpdate;
            delete newItem.isArchived;
            return newItem;
          }
        });
      }
      // filter formatValues
      formatValues = formatValues.filter((i) => {
        return (
          (!i.isArchived || (i.isArchived === true && i.id)) &&
          Object.keys(i).length > 1
        );
      });
      if (!formatValues.length) return;
      const request: any = {
        sectionId: WIZARD_STATE_PAGE.SERVICES,
        questions: [
          {
            questionTypeId: services[0].questionTypeId,
            values: formatValues,
          },
        ],
      };

      try {
        const res = await hanldleSetupServices(request);
        commit(
          "SET_VALUE_SERVICES",
          res.data.data.sections[0].questions[0].values,
        );
        return res;
      } catch (error) {
        throw { error, dataError: formatValues };
      }
    },

    hanldleSetupMisc: async (
      { state },
      { updateMiscPII = true, updateMiscPHI = true },
    ) => {
      const misc = state.questions[store.state.Org.currentOrg?.id].misc;
      const miscAnswer: any = {
        sectionId: WIZARD_STATE_PAGE.MISC,
        questions: [],
      };

      if (
        updateMiscPII &&
        state.valueMisc.miscPII &&
        misc[0].values.length == 0
      ) {
        const valuesArray: any = [];
        valuesArray.push({
          name:
            "Answered From Org Setup: PII" + +Math.floor(Math.random() * 1000),
          startDate: new Date(),
          isArchived: false,
        });

        const newQuestion = {
          questionTypeId: misc[0].questionTypeId,
          values: valuesArray,
        };

        miscAnswer.questions.push(newQuestion);
      }

      if (
        updateMiscPHI &&
        state.valueMisc.miscPHI &&
        misc[1].values.length == 0
      ) {
        const valuesArray: any = [];
        valuesArray.push({
          name:
            "Answered From Org Setup: PHI" + Math.floor(Math.random() * 1000),
          startDate: new Date(),
          isArchived: false,
        });

        const newQuestion = {
          questionTypeId: misc[1].questionTypeId,
          values: valuesArray,
        };

        miscAnswer.questions.push(newQuestion);
      }

      misc.forEach((element, index) => {
        // PII
        if (updateMiscPII && index === 0 && misc[0].values.length > 0) {
          const valuesArray: any = element.values.map((value) => {
            const obj = {
              id: value.id,
              endDate: state.valueMisc.miscPII
                ? null
                : new Date(new Date().setDate(new Date().getDate() - 1)),
              isArchived: state.valueMisc.miscPII ? value.isArchived : false,
            };

            if (state.valueMisc.miscPII) {
              obj["name"] =
                "Answered From Org Setup: PII" +
                Math.floor(Math.random() * 1000);
              obj["startDate"] = new Date();
            }

            return obj;
          });

          const newQuestion = {
            questionTypeId: element.questionTypeId,
            values: valuesArray,
          };

          miscAnswer.questions.push(newQuestion);
        }

        // PHI
        if (updateMiscPHI && index === 1 && misc[1].values.length > 0) {
          const valuesArray: any = element.values.map((value) => {
            const obj = {
              id: value.id,
              isArchived: state.valueMisc.miscPHI ? value.isArchived : false,
              endDate: state.valueMisc.miscPHI
                ? null
                : new Date(new Date().setDate(new Date().getDate() - 1)),
            };

            if (state.valueMisc.miscPHI) {
              obj["name"] =
                "Answered From Org Setup: PHI" +
                Math.floor(Math.random() * 1000);
              obj["startDate"] = new Date();
            }

            return obj;
          });
          const newQuestion = {
            questionTypeId: element.questionTypeId,
            values: valuesArray,
          };
          miscAnswer.questions.push(newQuestion);
        }
      });
      if (
        miscAnswer.questions.length === 0 ||
        (miscAnswer.questions[0].values.length === 0 &&
          miscAnswer.questions[1].values.length === 0)
      )
        return;

      return await hanldleSetupMisc(miscAnswer);
    },

    hanldleSetupSite: async ({ state }, data) => {
      const sites = state.questions[store.state.Org.currentOrg?.id].sites;
      const sitesAnswer: any = {
        sectionId: WIZARD_STATE_PAGE.SITES,
        questions: [
          {
            questionTypeId: sites[0].questionTypeId,
            values: data.data,
          },
        ],
      };
      return await hanldleSetupSite(sitesAnswer);
    },
    hanldleSetupTeams: async ({ state }, listUpdated: any[]) => {
      const listTeams = state.questions[store.state.Org.currentOrg?.id].teams;
      const listAnser: any = {
        sectionId: WIZARD_STATE_PAGE.TEAMS,
        questions: [
          {
            questionTypeId: listTeams[0].questionTypeId,
            values: [],
          },
        ],
      };

      const fieldsValidUpdated = [
        "id",
        "siteId",
        "teamTypeId",
        "headcount",
        "details",
        "notes",
        "startDate",
        "endDate",
        "isArchived",
        "teamLegalTypeId",
      ];

      listUpdated.forEach((item) => {
        const objUpdate = {} as any;

        fieldsValidUpdated.forEach((field) => {
          if (item[field]) objUpdate[field] = item[field];
        });

        listAnser.questions[0].values.push(
          objUpdate.id ? objUpdate : { ...objUpdate, startDate: new Date() },
        );
      });

      return await hanldleSetupTeams(listAnser);
    },

    hanldleSetupWebFacing: async ({ state }, data) => {
      const listWebFacing =
        state.questions[store.state.Org.currentOrg?.id].webservices;
      const listAnser: any = {
        sectionId: WIZARD_STATE_PAGE.WEBSERVICES,
        questions: [
          {
            questionTypeId: listWebFacing[0].questionTypeId,
            values: [],
          },
          {
            questionTypeId: listWebFacing[1].questionTypeId,
            values: [],
          },
        ],
      };
      if (state.indexUpdate === null) {
        data.listWeb.forEach((element) => {
          const questionObj = {
            ...(element.id ? { id: element.id } : {}),
            serviceTypeId: !element.id ? WIZARD_STATE_PAGE.WEBSITE : null,
            ...(element.typeId || element.typeId === null
              ? { typeId: element.typeId }
              : null),
            url: element.url || null,
            notes: element.notes ? element.notes : null,
            startDate: !element.id ? new Date() : null,
            description: element.name || null,
            isArchived: element.isArchived ?? null,
            ...(element.endDate ? { endDate: element.endDate } : null),
          };
          // remove null values
          Object.keys(questionObj).forEach(
            (key) => questionObj[key] === null && delete questionObj[key],
          );
          listAnser.questions[0].values.push(questionObj);
        });
        data.listApp.forEach((element) => {
          const questionObj = {
            ...(element.id ? { id: element.id } : {}),
            serviceTypeId: element.id ? null : WIZARD_STATE_PAGE.WEBNAT,
            ...(element.typeId ? { typeId: element.typeId } : {}),
            notes: element.notes ? element.notes : null,
            startDate: element.id ? null : new Date(),
            appName: element.name || null,
            description: element.description || null,
            isMobile: element.id
              ? element.isMobile === undefined
                ? null
                : element.isMobile
              : false,
            isDesktop: element.id
              ? element.isDesktop === undefined
                ? null
                : element.isDesktop
              : false,
            isArchived: element.isArchived ?? null,
            ...(element.endDate ? { endDate: element.endDate } : null),
          };
          // remove null values
          Object.keys(questionObj).forEach(
            (key) => questionObj[key] === null && delete questionObj[key],
          );
          listAnser.questions[1].values.push(questionObj);
        });
      } else {
        if (data.listWeb.length > 0) {
          listAnser.questions[0].values.push({
            id: data.listWeb[0].id,
            isArchived: data.listWeb[0].isArchived,
            endDate: data.listWeb[0].endDate,
          });
        }
        if (data.listApp.length > 0) {
          listAnser.questions[1].values.push({
            id: data.listApp[0].id,
            isArchived: data.listApp[0].isArchived,
            endDate: data.listApp[0].endDate,
          });
        }
      }
      if (data.listWeb.length == 0) {
        listAnser.questions.splice(0, 1);
      } else if (data.listApp == 0) {
        listAnser.questions.splice(1, 1);
      }

      state.indexUpdate = null;
      if (data.isDelete) return;
      return await hanldleSetupWebFacing(listAnser);
    },

    fetchQuestion: async ({ commit }) => {
      try {
        const res = await getWizardQuestion();
        const data: IWizardQuestionsResponse = get(
          res,
          "data.data",
          {} as IWizardQuestionsResponse,
        );
        const result = initialDataToStore(data, data.idOrg);
        result[data.idOrg].webservices[0].values.forEach((element) => {
          element.isStatus = 1;
        });
        result[data.idOrg].webservices[1].values.forEach((element) => {
          element.isStatus = 0;
        });
        commit("SET_QUESTIONS", result);
        commit("SET_STATE_API_SETUP", true);

        commit("SET_VALUE_SERVICES", result[data.idOrg].services[0].values);
        commit("SET_VALUES_WEBSERVICES", result[data.idOrg].webservices);
      } catch (error) {
        showErrorAPI(error, Org.getOrgSetup);
      }
    },
    onModalSetupWizard({ commit }, value) {
      commit("SET_ON_MODAL_SETUP_WIZARD", value);
    },
    updateQuestions: ({ commit }, { value, orgId, typeId, page }) => {
      commit("SET_VALUES_QUESTIONS", { value, orgId, typeId, page });
    },
    updateValueSitesQuestions: ({ commit }, payload) => {
      commit("SET_VALUES_SITES_QUESTIONS", payload);
    },
    updateValuesItem: ({ commit }, data) => {
      commit("UPDATE_VALUES_ITEM", data);
    },
    handleSetupOrg: async ({ commit, state }) => {
      const listAnswer: any = {
        sectionId: WIZARD_STATE_PAGE.ORG,
        questions: [],
      };
      state.questions[store.state.Org.currentOrg?.id].org.forEach(
        (el: any, index) => {
          const endDate = new Date().toISOString();
          const questionObj: any = {
            questionTypeId: el.questionTypeId,
            values: el.values.map((element: any) => {
              if (element.id) {
                element.endDate = element.endDate || endDate;
                const output: any = {
                  id: element.id,
                  startDate: element.startDate,
                  endDate: element.endDate || endDate,
                  isArchived: element.isArchived,
                };
                if (element.lifecycleId) {
                  output.lifecycleId = element.lifecycleId;
                } else if (element.marketId) {
                  output.marketId = element.marketId;
                } else if (element.industryId) {
                  output.industryId = element.industryId;
                } else {
                  output.revenueBandId = element.revenueBandId;
                }
                return output;
              }

              let keyId;
              let valueKey;
              if (index === 0) {
                keyId = "lifecycleId";
                valueKey = element.lifecycleId || element;
              } else if (index === 1) {
                keyId = "industryId";
                valueKey = element.industryId || element;
              } else if (index === 2) {
                keyId = "marketId";
                valueKey = element.marketId || element;
              } else {
                keyId = "revenueBandId";
                valueKey = element.revenueBandId || element;
              }
              return {
                [keyId]: valueKey,
                startDate: endDate,
                // description: "",
                // notes: "",
              };
            }),
          };
          listAnswer.questions.push(questionObj);
        },
      );

      listAnswer.questions.forEach((element) => {
        element.values = element.values.filter((item) => {
          return !item.id;
        });
      });

      const res = await haldleSetupOrganisationOrg({
        ...listAnswer,
        questions: listAnswer.questions.filter(
          (q) => q.values && q.values.length > 0,
        ),
      });
      commit("UPDATE_DATA", get(res, "data.data"));

      const questions = get(res, "data.data.sections[0].questions", [] as any);
      state.questions[store.state.Org.currentOrg?.id].org.forEach(
        (elem: any, index: number) => {
          questions[index].values.sort(
            (a: any, b: any) => Number(a.id) - Number(b.id),
          );
          elem.values = questions[index].values || elem.values;
        },
      );
      state.questionsCache = JSON.stringify(state.questions);
      return res;
    },
  },
};

export default wizardModule;
